import CardDisplay from './CardDisplay';
import { Grid, Typography, useTheme } from '@mui/material';
import { Svgs } from '../assets/svg';
import Spacer from './Spacer';
import React from 'react';

interface RefreshButtonProps {
  onRefresh: () => void;
  disabled?: boolean;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({ onRefresh, disabled }) => {
  const theme = useTheme();

  return (
    <CardDisplay
      onClick={onRefresh}
      disabled={disabled}
      sx={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1.5),
        maxHeight: theme.spacing(8),
        boxSizing: 'border-box',
        minWidth: 'auto',
      }}>
      <Grid display='flex' flexDirection='row' alignItems='center'>
        <Svgs.ActionSmallRefreshDefault
          style={{
            width: theme.spacing(4),
            height: theme.spacing(4),
          }}
          color={disabled ? theme.palette.info.main : theme.palette.primary.main}
        />
        <Spacer width='xxs' />
        <Typography variant='p16' color='secondary.dark'>
          Refresh
        </Typography>
      </Grid>
    </CardDisplay>
  );
};

export default RefreshButton;
